import script from "./ManageReportsCreateEditBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageReportsCreateEditBox.vue?vue&type=script&setup=true&lang=js"

import "./ManageReportsCreateEditBox.vue?vue&type=style&index=0&id=3006e53c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3006e53c"]])

export default __exports__